import { initCommerceApiWithGlobals } from 'common-api';
import { logger, isBrowser } from 'common-ui';
import { getRecoil, setRecoil } from 'recoil-nexus';
import { authAtom } from '../../atoms/authAtom';
import { commerceApiExtraConfig, cartAtom } from '../../atoms/cartAtom';
import { commonHandlerForWebApiRequestError } from '../../helpers/commonHandlerForWebApiRequestError';
import { getProducts } from '../../helpers/getProducts';
import { handlePromoCodeValidation } from '../../helpers/handlePromoCodeValidation';
import { getCurrentCartIdFromCookie } from '../../helpers/utils';
import { reloadAuthToken } from '../../helpers/auth/reloadAuthToken';

export async function fetchCartWithWebApi(): Promise<void> {
  async function doFetchCart() {
    if (!isBrowser()) {
      logger.log('fetchCartWithWebApi skipping as not in browser');
      return;
    }

    let authAtomState = getRecoil(authAtom);

    // If public CSRF is not available in state, then fetch from /pagereload endpoint
    if (!authAtomState?.publicCsrf) {
      authAtomState = (await reloadAuthToken()) || authAtomState;
    }

    const commerceApi = initCommerceApiWithGlobals(commerceApiExtraConfig(authAtomState.publicCsrf));

    const { cartId } = getCurrentCartIdFromCookie();

    const newCartData = await commerceApi.CartPreferences.getMyCart({ cartId });

    handlePromoCodeValidation(newCartData);

    // Pass the Cart data to getProducts fn to fetch product details
    const productArray = await getProducts(newCartData);

    // Update the cart state with products (if available)
    setRecoil(cartAtom, prevState => ({
      ...prevState,
      cartIsLoaded: true,
      cartItems: {
        ...prevState.cartItems,
        ...newCartData,
        ...(productArray?.length ? { lineItems: productArray } : {}),
      },
    }));
  }

  try {
    await doFetchCart();
  } catch (e: any) {
    return commonHandlerForWebApiRequestError(e, doFetchCart);
  }
}
